/* ============================================================
   LDS satelitska podloga (MapLibre style) — jedan izvor istine.
   Koriste je: maplibre-amap-adapter (live-ops mapa) i Editor misija.
   Esri World Imagery (besplatno, bez ključa, WGS84) + granice/nazivi.
   ============================================================ */
import type { StyleSpecification } from 'maplibre-gl'

// Srbija (centar), Bor ~ [22.10, 44.07]
export const SERBIA_CENTER: [number, number] = [21.0, 44.0]

export function ldsSatelliteStyle (): StyleSpecification {
  return {
    version: 8,
    // font glifovi (za tekst oznake u 3D) — MapLibre demotiles, CORS otvoren
    glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf',
    sources: {
      satellite: {
        type: 'raster',
        tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
        tileSize: 256,
        // za Bor Esri ima snimke do nivoa 18 (19 i 20 = "Map data not yet available", 30.10.2026)
        maxzoom: 18,
        attribution: 'Esri World Imagery'
      },
      labels: {
        type: 'raster',
        tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}'],
        tileSize: 256
      }
    },
    layers: [
      { id: 'satellite', type: 'raster', source: 'satellite' },
      { id: 'labels', type: 'raster', source: 'labels', paint: { 'raster-opacity': 0.7 } }
    ]
  }
}
